import { Box, Flex, Image } from "@chakra-ui/react";
import React from "react";
import EnrolledCourseDesc from "./enrolled-course-desc";
import ContinueLearning from "./continuelearning";
import { ROUTE_NAMES } from "@root/constants";
import { useNavigate } from "react-router-dom";
import useMediaQ from "@root/hooks/useMediaQ";
import defaultThumbnail from "@root/assets/images/Course Thunbnail.png";
import MobileEnrolledCourse from "./MobileEnrolledCourse";

const DEFAULT_THUMBNAIL = defaultThumbnail;

const EnrolledCourse: React.FC<any> = ({ course }) => {
  const navigate = useNavigate();
  const { sm } = useMediaQ();
  const isMobile = !sm;
  const courseData = course?.course;

  if (isMobile) {
    return <MobileEnrolledCourse course={course} />;
  }

  // Desktop version
  return (
    <Flex
      w="100%"
      minH="154px"
      gap="40px"
      borderRadius="12px"
      borderWidth="1px"
      p="16px"
      borderColor="#CDD6DC"
      direction="row"
      alignItems="flex-start"
    >
      <Box
        w="180px"
        h="120px"
        flexShrink={0}
        borderRadius="9px"
        overflow="hidden"
      >
        <Image
          src={courseData?.thumbnail || DEFAULT_THUMBNAIL}
          borderRadius="9"
          w="100%"
          h="100%"
          objectFit="contain"
        />
      </Box>

      {/* Description */}
      <EnrolledCourseDesc course={course} />

      <Flex
        flex="1"
        h="100%"
        alignItems="center"
        justifyContent="flex-end"
        w="auto"
        onClick={() =>
          navigate(`${ROUTE_NAMES.JOURNALIST_COURSE_DETAIL}/${courseData?.id}`)
        }
      >
        <ContinueLearning />
      </Flex>
    </Flex>
  );
};

export default EnrolledCourse;
